/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_VibebidsInputs */

const en_common_header_vibebids = /** @type {(inputs: Common_Header_VibebidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids`)
};

const zh_common_header_vibebids = /** @type {(inputs: Common_Header_VibebidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids`)
};

/**
* | output |
* | --- |
* | "VibeBids" |
*
* @param {Common_Header_VibebidsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_vibebids = /** @type {((inputs?: Common_Header_VibebidsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_VibebidsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_vibebids(inputs)
	return zh_common_header_vibebids(inputs)
});
export { common_header_vibebids as "common.header.vibebids" }